<template>
    <div class="about">
        <h1>User Guide</h1>
        <pdf v-for="i in 9"
             :key="i"
             src="./guide.pdf"
             :page="i"
             style="display: inline-block; width: 75%" />
    </div>
</template>

<script>
    import pdf from 'vue-pdf';
    import {Vue, Component} from 'vue-property-decorator';

    @Component({
        components: {
            pdf
        }
    })
    export default class About extends Vue {}
</script>
